import React from "react";
import { useOnboarding } from "../../contexts/OnboardingContext";

const FREDOKA = { fontFamily: "'Fredoka', sans-serif" };

const OnboardingProgress = () => {
  const { currentStep, totalSteps } = useOnboarding();
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="flex items-center gap-3">
      <span style={{ ...FREDOKA, color: "#5A6B85", fontSize: 11, fontWeight: 800, letterSpacing: "0.14em", textTransform: "uppercase" }}>
        Step <strong style={{ color: "#0065F8" }}>{currentStep}</strong> / {totalSteps}
      </span>
      <div
        style={{
          width: 128,
          height: 8,
          background: "rgba(11,26,51,0.08)",
          borderRadius: 999,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            background: "linear-gradient(90deg, #0065F8 0%, #00CAFF 100%)",
            borderRadius: 999,
            boxShadow: "0 0 12px rgba(0,101,248,0.30)",
            transition: "width 700ms ease",
          }}
        />
      </div>
    </div>
  );
};

export default OnboardingProgress;
